var render = function render(_c,_vm){return _c('v-btn',_vm._b({class:_vm.props.marginClass,attrs:{"dark":"","width":"140px","to":_vm.props.to,"height":"40px","color":"eventResultsBtn"}},'v-btn',_vm.attrs,false),[_vm._v("\n  "+_vm._s(_vm.parent.$t("common:results.button"))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }